module.exports = __webpack_public_path__ + "img/icon-banner-dex-pn-dark.8a601a52.svg";